import Yup from "../localizedYup";

const paymentValidationSchema = Yup.object({
  conditionType: Yup.object({ id: Yup.number().required() }).required(),
  amount: Yup.number().required(),
  currency: Yup.string().required(),
  paymentDate: Yup.date().required(),
  description: Yup.string(),
});

export { paymentValidationSchema };
